import { ITab } from "../../../utils/interfaces";

export const TabItems: Array<ITab> = [
    {
        id: 0,
        label: "Schedule Now",
        src: "/schedule",
        visible: false
    },
    {
        id: 1,
        label: "Ask Ralphie",
        src: "/askRalphie",
        visible: true,
    },
    {
        id: 2,
        label: "Appointments",
        src: "/appointments",
        visible: false
    },
    {
        id: 3,
        label: "Pets",
        src: "/pets",
        visible: false
    },
    {
        id: 4,
        label: "Preferences",
        src: "/preferences",
        visible: false
    },
    {
        id: 5,
        label: "Account Settings",
        src: "/dashboardProfile",
        visible: false
    },
    {
        id: 6,
        label: "Login",
        src: "/login/?login=true",
        visible: true,
    },
    {
        id: 7,
        label: "Sign Up",
        src: "/signUp",
        visible: true
    },
    {
        id: 8,
        label: "Sign Out",
        src: "/login/?login=true",
        visible: false
    }
];
